const $ = require('jquery');
require('jquery-validation');
require('jquery-mask-plugin');
import sendEmail from "./send_form";
// todo: add js documentation
$(document).ready(function () {
    $('.price-phone').mask('+380(00)000-00-00', {placeholder: '+380(__)___-__-__'});
    $('.phone-input').mask('+380 (00) 000-00-00');
    $('.diagnostic-popup__phone').mask('+380 (00) 000-00-00');
    const maxNameLength = 250;
    const $priceNameInput = $('.price-name');

    $(".calc-form__price").validate({
        rules: {
            'name': {
                required: true,
                minlength: 2,
                maxlength: maxNameLength,
            },
            'phone': {
                required: true,
                minlength: 17
            }
        },
        messages: {
            'name': {
                required: "Це поле обов'язкове для заповнення",
                minlength: "Мінімальна кількість символів 2",
                maxlength: "Максимальна кількість символів " + maxNameLength,
            },
            'phone': {
                required: "Це поле обов'язкове для заповнення",
                minlength: "Не коректний формат введеного номеру"
            }
        },
        submitHandler: function (form) {
            const button = $('.price-button');
            const originalText = button.html();
            const customSpinner = '<div class="custom-spinner" style="width: 24px; height: 24px; border: 3px solid #000; border-top: 3px solid #F1D331; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto"></div>';

            button.html(customSpinner); // * Замінюємо вміст кнопки на власний спінер
            button.attr('disabled', 'disabled');

            let newForm = new FormData(form);
            event.preventDefault();
            newForm.get("_token");
            var serviceElements = document.querySelectorAll('.select-selected-service');
            var serviceArray = [];
            serviceElements.forEach(function (element) {
                var text = element.textContent.trim();
                serviceArray.push(text);
            });

            var detailsArray = [];
            var detailElements = document.querySelectorAll('.select-selected-details');
            detailElements.forEach(function (element) {
                if (element.textContent !== $t('site_labels.select_detail'))
                    detailsArray.push(element.textContent);
            });
            let finalPrice = $('.final-value__price').text();
            $('.price-name').val('');
            $('.price-phone').val('');
            sendEmail(this.currentForm, newForm, {
                serviceArray,
                finalPrice,
                detailsArray,
            });

        }
    });

    $priceNameInput.on('input', function () {
        var inputValue = $(this).val();
        var sanitizedValue = inputValue.replace(/[^a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ\s-]/g, '');
        if (sanitizedValue.length > maxNameLength) {
            sanitizedValue = sanitizedValue.substring(0, maxNameLength);
        }
        $(this).val(sanitizedValue);
    });

    $("#question-form").validate({
        rules: {
            'name': {
                required: true,
                minlength: 2,
                // pattern: /^[A-Za-z -]+$/,
            },
            'surname': {
                minlength: 2,
                // pattern: /^[A-Za-z -]+$/,
            },
            'email': {
                required: true,
                email: true
            },
            'phone': {
                required: true,
                minlength: 19,

            },
            'message': {
                required: false,
                maxlength: 500,
            }
        },
        messages: {
            name: {
                required: "Це поле обов'язкове для введення",
                // pattern: "Не коректна форма введення імені",
                minlength: "Мінімальна кількість символів 2",
            },
            surname: {
                // pattern: "Не коректна форма введення прізвища",
                minlength: "Мінімальна кількість символів 2",
            },
            email: {
                required: "Це поле обов'язкове для введення",
                email: "Не коректно введена форма email",
            },
            phone: {
                required: "Це поле обов'язкове для введення",
                minlength: "Не коректно введено номер телефону",
            },
            message: {
                maxlength: "Максимальна кількість символів 500",
            }
        },
        submitHandler: function (form) {
            const button = $('.send-form');
            const originalText = button.html();
            const customSpinner = '<div class="custom-spinner" style="width: 24px; height: 24px; border: 3px solid #000; border-top: 3px solid #F1D331; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto"></div>';

            button.html(customSpinner);
            button.attr('disabled', 'disabled');
            let newForm = new FormData(form);
            event.preventDefault();
            newForm.get("_token");

            sendEmail(this.currentForm, newForm);
        }
    });

    $("#diagnostic-popup").validate({
        rules: {
            'name': {
                required: true,
                minlength: 2,
                maxlength: maxNameLength,
            },
            'phone': {
                required: true,
                minlength: 19
            }
        },
        messages: {
            'name': {
                required: "Це поле обов'язкове для заповнення",
                minlength: "Мінімальна кількість символів 2",
                maxlength: "Максимальна кількість символів " + maxNameLength,
            },
            'phone': {
                required: "Це поле обов'язкове для заповнення",
                minlength: "Не коректний формат введеного номеру"
            }
        },
        submitHandler: function (form) {
            const button = $('.diagnostic-popup__button');
            const originalText = button.html();
            const customSpinner = '<div class="custom-spinner" style="width: 24px; height: 24px; border: 3px solid #000; border-top: 3px solid #F1D331; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto"></div>';

            button.html(customSpinner);
            button.attr('disabled', 'disabled');
            let newForm = new FormData(form);
            event.preventDefault();
            newForm.get("_token");
            sendEmail(this.currentForm, newForm);
            $('.diagnostic-popup__name').val('');
            $('.diagnostic-popup__phone').val('');
        }
    });
    $('.diagnostic-popup__name').on('input', function () {
        var inputValue = $(this).val();
        var sanitizedValue = inputValue.replace(/[^a-zA-Zа-яА-ЯёЁіІїЇєЄґҐ\s-]/g, '');
        if (sanitizedValue.length > maxNameLength) {
            sanitizedValue = sanitizedValue.substring(0, maxNameLength);
        }
        $(this).val(sanitizedValue);
    });
});
